import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import {
    faAlignJustify,
    faArrowLeft,
    faArrowRight,
    faEllipsisV,
    faEraser,
    faExchangeAlt,
    faFile,
    faGamepad,
    faImage,
    faImages,
    faLink,
    faListOl,
    faListUl,
    faMinus,
    faRedo,
    faUndo,
    faQuoteRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button, ButtonGroup, ButtonToolbar, Col, Form, FormGroup, Row,
    ToggleButton, ToggleButtonGroup, Accordion,
} from 'react-bootstrap';
import { HotKeys } from 'react-hotkeys';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { BB2HTML } from './bb2html_converter';
import { buildArticleURL, buildCompilationsURL, buildNewsURL } from './build_urls';
import {
    twitchPlaceholder, twitchPlaceholderClip, twitchPlaceholderVideo, telegramPlaceholder,
} from './social-placeholders';
import { StdModalDialog } from '../blocks/dialog';
import {
    InputField, SearchSelectorField, SelectorField, TextAreaField, CheckboxField,
} from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import EventStore from '../common/observer';
import {
    API_DOMAIN, GAMES_URL, ENT_TYPES, PROJECT_DOMAINS,
} from '../const';
import vkSrc from '../img/vk-logo.svg';
import EditableTable from '../screens/EditableTable';
import '../css/text-editor.css';

library.add(
    faListOl,
    faListUl,
    faGamepad,
    faImages,
    faImage,
    faFile,
    faEraser,
    faExchangeAlt,
    faLink,
    faTwitter,
    faAlignJustify,
    faArrowRight,
    faArrowLeft,
    faMinus,
    faEllipsisV,
    faUndo,
    faRedo,
    faQuoteRight,
);

const twitchTypeLabel = {
    clip: 'Клип',
    video: 'Видео',
    chanel: 'Канал',
};

const labelStyle = {
    color: '#6441a5',
    fontWeight: 'bold',
};

const labelStyleSub = {
    color: '#00a86b',
    fontWeight: 'bold',
};

const twitchPlaceholders = {
    clip: 'FaintNaiveRingHeyGirl',
    video: '372767247',
    chanel: 'mcdm',
};

const FACEBOOK = {
    appId: '137691964514530',
    clientToken: 'b4bf8f422b206e22854477929346fdaf',
};

export default class TextEditor extends React.Component {
    constructor(props) {
        // rows - int;
        // descr - text;
        super(props);
        this.twitterUrlRef = React.createRef();
        this.twitterTranslateRef = React.createRef();
        this.linkUrlRef = React.createRef();
        this.videoUrlRef = React.createRef();
        this.gameUrlRef = React.createRef();
        this.replaceWordRef = React.createRef();

        this.quoteText = React.createRef();

        this.text = React.createRef();
        this.cursor = React.createRef();

        this.onSelection = this.onSelection.bind(this);
        this.onPreview = this.onPreview.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onInlineStyleChange = this.onInlineStyleChange.bind(this);
        this.onListStyleChange = this.onListStyleChange.bind(this);
        this.onInlineSymbolsChange = this.onInlineSymbolsChange.bind(this);
        this.onInlineLinkChange = this.onInlineLinkChange.bind(this);
        this.cleanUpFormat = this.cleanUpFormat.bind(this);

        this.toggleReplDialog = this.toggleReplDialog.bind(this);
        this.onReplaceWord = this.onReplaceWord.bind(this);
        this.replaceWords = this.replaceWords.bind(this);

        this.toggleGameLinkDialog = this.toggleGameLinkDialog.bind(this);
        this.onGameSelection = this.onGameSelection.bind(this);
        this.tryinFetchGame = this.tryinFetchGame.bind(this);
        this.getGame = this.getGame.bind(this);

        this.toggleUrlUrlDialog = this.toggleUrlUrlDialog.bind(this);
        this.toggleEntsBlockDialog = this.toggleEntsBlockDialog.bind(this);
        this.toggleTwitterUrlDialog = this.toggleTwitterUrlDialog.bind(this);
        this.toggleVideoUrlDialog = this.toggleVideoUrlDialog.bind(this);
        this.toggleGames_downloadUrlDialog = this.toggleGames_downloadUrlDialog.bind(this);

        this.toggleQuoteDialog = this.toggleQuoteDialog.bind(this);
        this.onQuoteEdit = this.onQuoteEdit.bind(this);
        this.onQuoteInsert = this.onQuoteInsert.bind(this);

        this.onLinkChange = this.onLinkChange.bind(this);
        this.onLinkInsert = this.onLinkInsert.bind(this);
        this.socialRawId = this.socialRawId.bind(this);
        this.addSocialBlock = this.addSocialBlock.bind(this);
        this.addEntitiesBlock = this.addEntitiesBlock.bind(this);

        this.entityTypeSelected = this.entityTypeSelected.bind(this);
        this.entitySearchChange = this.entitySearchChange.bind(this);
        this.appendSelectedEntity = this.appendSelectedEntity.bind(this);
        this.removeSelectedEntity = this.removeSelectedEntity.bind(this);
        this.getSelectedEntitys = this.getSelectedEntitys.bind(this);
        this.onEntityInsert = this.onEntityInsert.bind(this);

        this.getTextFromHistoryRedo = this.getTextFromHistoryRedo.bind(this);
        this.getTextFromHistoryUndo = this.getTextFromHistoryUndo.bind(this);

        this.onDownloadLinkInsert = this.onDownloadLinkInsert.bind(this);

        this.cleanupInputs = this.cleanupInputs.bind(this);

        this.pictureSelected = this.pictureSelected.bind(this);

        this.tableUpdateHandler = this.tableUpdateHandler.bind(this);

        this.state = {
            current_selection: '',
            text: this.props.descr,
            isPreview: false,
            entity_alias: 'news',
            replaceDialogOpen: false,
            gameLinkDialogOpen: false,
            twitterUrlDialogOpen: false,
            twitchUrlDialogOpen: false,
            instagramUrlDialogOpen: false,
            telegramUrlDialogOpen: false,
            videoUrlDialogOpen: false,
            videoVKUrlDialogOpen: false,
            games_downloadUrlDialogOpen: false,
            linkUrlDialogOpen: false,
            selectedEntitys: [],
            textHistoryUndo: [],
            textHistoryRedo: [],
            table: {},
            tableDialogOpen: false,
            asideDialogOpen: false,
            materialType: 'hard',
            twitchType: 'clip',
            more_project: 'media.vkplay.ru',
        };
    }

    getTextFromHistoryRedo() {
        const result = this.state.textHistoryRedo.slice(-1)[0];

        if (!result) {
            return;
        }

        const currentRedoHistory = this.state.textHistoryRedo;
        currentRedoHistory.splice(-1, 1);

        const currentUndoHistory = this.state.textHistoryUndo;
        currentUndoHistory.push(this.state.text);
        this.setState({ textHistoryRedo: currentRedoHistory, textHistoryUndo: currentUndoHistory, text: result });
    }

    getTextFromHistoryUndo() {
        const result = this.state.textHistoryUndo.slice(-1)[0];

        if (!result) {
            return;
        }

        const currentUndoHistory = this.state.textHistoryUndo;
        currentUndoHistory.splice(-1, 1);

        const currentRedoHistory = this.state.textHistoryRedo;
        currentRedoHistory.push(this.state.text);
        this.setState({ textHistoryUndo: currentUndoHistory, textHistoryRedo: currentRedoHistory, text: result });
    }

    storeTextToHistory(value) {
        if (!value) {
            return;
        }

        const currentHistory = this.state.textHistoryUndo;
        currentHistory.push(value);
        this.setState({ textHistoryUndo: currentHistory });
    }

    componentWillReceiveProps(nextProps) {
        this.storeTextToHistory(this.state.text);
        this.setState({ text: nextProps.descr });
    }

    _setCursorPositions = () => {
        if (this.text.current && this.text.current.selectionStart !== this.cursor) {
            console.log(this.text.current.selectionStart, this.cursor);
            this.text.current.selectionStart = this.cursor - 1;
            this.text.current.selectionEnd = this.cursor - 1;
        }
    };

    onTextChange(event) {
        this.cursor = event.target.selectionStart;
        let text = event.target.value;
        text = text.replace(/ - /g, ' — ').replace(/"(.*?)"/g, '«$1»');

        if (event.currentTarget.selectionStart && event.currentTarget.selectionEnd) {
            this.setState({
                current_selection: {
                    selectionStart: event.currentTarget.selectionStart,
                    selectionEnd: event.currentTarget.selectionEnd,
                    value: text,
                },
                text,
            });
        }

        this.props.onChange({
            target: {
                id: this.props.id,
                type: this.props.id,
                value: text,
                multiData: event.multiData,
            },
            currentTarget: {
                id: this.props.id,
                type: this.props.id,
                value: text,
                multiData: event.multiData,
            },
            type: event.type,
        });
    }

    onInlineStyleChange(event) {
        // Обработка однострочных тагов
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        const open_style_code = `[${event.currentTarget.id.replace('_code', '')}]`;
        const close_style_code = `[/${event.currentTarget.id.replace('_code', '')}]`;

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        // Добавляем закрывающий таг
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);

        event.currentTarget.value = current_value;
        event.target.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    onListStyleChange(event) {
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        const open_style_code = `[list=${event.currentTarget.id.replace('_code', '')}]\n`;
        const close_style_code = '[/list]\n';

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        let new_value = '';
        const selected_text = current_value.slice(sel_start, sel_end);

        for (let i = 0; i < selected_text.split('\n').length; i++) {
            new_value += `[*] ${selected_text.split('\n')[i]}\n`;
        }

        new_value = open_style_code + new_value + close_style_code;

        if (!selected_text) {
            current_value = current_value.slice(0, sel_start) + new_value + current_value.slice(sel_start);
        } else {
            current_value = current_value.replace(selected_text, new_value);
        }

        event.target.value = current_value;
        event.currentTarget.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    onInlineSymbolsChange(event) {
        const symbol_type = event.currentTarget.id.replace('_code', '');
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        let open_style_code = '';
        let close_style_code = '';

        if (symbol_type === 'nbsp') {
            close_style_code = '&nbsp;';
        }

        if (symbol_type === 'chevron') {
            open_style_code = '«';
            close_style_code = '»';
        }

        if (symbol_type === 'dash') {
            open_style_code = '';
            close_style_code = '—';
        }

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);

        event.target.value = current_value;
        event.currentTarget.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    onInlineLinkChange(event) {
        const link_type = event.currentTarget.id.replace('_code', '');
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        let open_style_code = '';
        let close_style_code = '';

        if (link_type === 'url') {
            open_style_code = '[url=]';
            close_style_code = '[/url]';
        }

        if (link_type === 'twitter') {
            open_style_code = '[twitter=]';
            close_style_code = '[/twitter]';
        }

        if (link_type === 'video') {
            open_style_code = '[video=]';
            close_style_code = '[/video]';
        }

        if (link_type === 'file') {
            open_style_code = '[games_download=]';
            close_style_code = '[/games_download]';
        }

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);
        event.target.value = current_value;
        event.currentTarget.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    onSelection(event) {
        this.setState({ current_selection: event.target });
    }

    onPreview() {
        this.setState({ isPreview: !this.state.isPreview });
    }

    handleClick(e) {
        if (e) {
            e.preventDefault();
        }
    }

    handleTableChange = (grid, html) => {
        this.setState({
            table: { grid, html },
        });
    };

    handleQuoteStyling = (e) => {
        const textarea = document.getElementById('quote_text');

        const valueStart = textarea.value.slice(0, textarea.selectionStart);
        const valueMiddle = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
        const valueEnd = textarea.value.slice(textarea.selectionEnd, textarea.value.length);
        const tag = e.currentTarget.dataset.code;

        const newValue = `${valueStart}[${tag}${tag === 'url' ? '=' : ''}]${valueMiddle}[/${tag}]${valueEnd}`;

        this.setState({ quote_text: newValue });
    };

    getQuoteButtons() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="inlineStyleBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Курсив"
                    data-code="i"
                    onClick={this.handleQuoteStyling}
                    href="#"
                >
                    <i>I</i>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Подчеркнутый"
                    data-code="u"
                    onClick={this.handleQuoteStyling}
                    href="#"
                >
                    <u>U</u>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Зачеркнутый"
                    data-code="s"
                    onClick={this.handleQuoteStyling}
                    href="#"
                >
                    <s>S</s>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Ссылка"
                    data-code="url"
                    onClick={this.handleQuoteStyling}
                    href="#"
                >
                    <FontAwesomeIcon icon="link" />
                </Button>
            </ButtonGroup>
        );
    }

    inlineStyleBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="inlineStyleBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Жирный"
                    id="b_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <b>B</b>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Курсив"
                    id="i_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <i>I</i>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Подчеркнутый"
                    id="u_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <u>U</u>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Зачеркнутый"
                    id="s_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <s>S</s>

                </Button>
            </ButtonGroup>
        );
    }

    headersStyleBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="headersStyleBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Заголовок H2"
                    id="h2_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <b>H2</b>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Заголовок H3"
                    id="h3_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <b>H3</b>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Подстрочный индекс"
                    id="sub_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    X
                    <sub>2</sub>

                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Надстрочный индекс"
                    id="sup_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    X
                    <sup>2</sup>

                </Button>
            </ButtonGroup>
        );
    }

    listStyleBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" key="listStyleBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Нумерованный список"
                    id="123_code"
                    onClick={this.onListStyleChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="list-ol" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Маркированный список"
                    id="_code"
                    onClick={this.onListStyleChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="list-ul" />
                </Button>
            </ButtonGroup>
        );
    }

    specSymbolsBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="specSymbolsBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Неразрывный пробел"
                    id="nbsp_code"
                    onClick={this.onInlineSymbolsChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="arrow-right" />
                    _
                    <FontAwesomeIcon icon="arrow-left" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Кавычки"
                    id="chevron_code"
                    onClick={this.onInlineSymbolsChange}
                    href="#"
                >
                    « »
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Тире"
                    id="dash_code"
                    onClick={this.onInlineSymbolsChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="minus" />
                </Button>
            </ButtonGroup>
        );
    }

    linksStyleShortBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" key="linksStyleShortBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Ссылка"
                    id="url_code"
                    onClick={this.toggleUrlUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="link" />
                </Button>
            </ButtonGroup>
        );
    }

    getGame(data) {
        if (data.count === 1) {
            const value = {
                value: data.results[0].id,
                name: data.results[0].name,
                slug: data.results[0].slug,
            };

            this.onGameSelection(
                {
                    target: { value },
                    currentTarget: { value },
                    noModal: true,
                },
            );
        } else {
            this.toggleGameLinkDialog();
        }
    }

    tryinFetchGame() {
        const selected_text = this.state.text.slice(
            this.state.current_selection.selectionStart,
            this.state.current_selection.selectionEnd,
        );

        Fetcher(`games/?search=${selected_text}`, 'GET', this.getGame);
    }

    componentDidMount() {
        this.setState({ text: this.props.descr.replace(/ - /g, ' — ').replace(/"(.*?)"/g, '«$1»') });

        if ((this.props.id === 'long_descr') || (this.props.id === 'text')) {
            EventStore.addListener('CHANGE', this.pictureSelected);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { text, current_selection } = this.state;

        if (prevState.text !== text) {
            this._setCursorPositions();
            this.text.current.value = this.state.text;
            this.text.current.selectionStart = current_selection.selectionStart;
            this.text.current.selectionEnd = current_selection.selectionEnd;
        }
    }

    textChunksBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="textChunksBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Цитата"
                    id="quote_code"
                    onClick={this.toggleQuoteDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="quote-right" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Врезка"
                    id="incut_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <b>|</b>
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Видео VK"
                    id="vk-video_code"
                    onClick={this.toggleVk_videoUrlDialog}
                    href="#"
                >
                    <img src={vkSrc} alt="vk" />
                </Button>
                {/* <Button variant={'outline-secondary'} size={"sm"} title={'Видео'} id={'video_code'}
                        onClick={this.toggleVideoUrlDialog} href={'#'}>
                    <FontAwesomeIcon icon="video"/>
                </Button> */}
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Таблица"
                    id="table_code"
                    onClick={this.toggleTableDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="table" />
                </Button>
            </ButtonGroup>
        );
    }

    linksStyleBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" onMouseDown={this.handleClick} key="linksStyleBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Ссылка"
                    id="url_code"
                    onClick={this.toggleUrlUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="link" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Twitter"
                    id="twitter_code"
                    onClick={this.toggleTwitterUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon={['fab', 'twitter']} />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Twitch"
                    id="twitch_code"
                    onClick={this.toggleTwitchUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon={['fab', 'twitch']} />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Instagram"
                    id="instagram_code"
                    onClick={this.toggleInstagramUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon={['fab', 'instagram']} />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Telegram"
                    id="telegram_code"
                    onClick={this.toggleTelegramUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon={['fab', 'telegram']} />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Цитата"
                    id="quote_code"
                    onClick={this.toggleQuoteDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="quote-right" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Врезка"
                    id="incut_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <b>|</b>
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Вставка"
                    id="aside_article_code"
                    onClick={this.toggleAsideDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="indent" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Таблица"
                    id="table_code"
                    onClick={this.toggleTableDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="table" />
                </Button>

                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Ссылка на игру"
                    id="url_code"
                    onClick={this.tryinFetchGame}
                    href="#"
                >
                    <FontAwesomeIcon icon="gamepad" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Видео"
                    id="video_code"
                    onClick={this.toggleVideoUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="video" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Группировка картинок"
                    id="games_img_group_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="image" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Галерея картинок"
                    id="games_img_gallery_code"
                    onClick={this.onInlineStyleChange}
                    href="#"
                >
                    <FontAwesomeIcon icon="images" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Ссылка на файл"
                    id="file_code"
                    onClick={this.toggleGames_downloadUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="file" />
                </Button>
            </ButtonGroup>
        );
    }

    cleanUpFormat() {
        const format_search = /(\[.*\])(.*?)\[\/.*\]/ig;
        this.setState({ text: this.state.text.replace(format_search, '$2') });
    }

    formatActionsBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" key="formatActionsBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Очистить разметку"
                    id="url_code"
                    onClick={this.cleanUpFormat}
                    href="#"
                >
                    <FontAwesomeIcon icon="eraser" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Автозамена"
                    id="url_code"
                    onClick={this.toggleReplDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="exchange-alt" />
                </Button>
            </ButtonGroup>
        );
    }

    footerBlock() {
        return (
            <ButtonGroup className="mr-2 mb-2" key="formatFooterBlock">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Вставить блок материалов по теме"
                    id="related_texts"
                    onClick={this.toggleEntsBlockDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="folder-plus" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Вставить блок ссылок на соц.сети"
                    id="s_links"
                    onClick={this.addSocialBlock}
                    href="#"
                >
                    <FontAwesomeIcon icon="rss" />
                </Button>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    title="Вставить сырой HTML"
                    id="raw_html"
                    onClick={this.toggleRawHtmlUrlDialog}
                    href="#"
                >
                    <FontAwesomeIcon icon="code" />
                </Button>

            </ButtonGroup>
        );
    }

    textInputBlock() {
        return (
            <Form.Control
                rows={this.props.rows || 10}
                as="textarea"
                onSelect={this.onSelection}
                onChange={this.onTextChange}
                ref={this.text}
                value={this.state.text}
                maxLength={this.props.maxLength}
                style={this.props.style}
                name={this.props.name}
            />
        );
    }

    textPreviewBlock() {
        return (BB2HTML(this.state.text));
    }

    toggleReplDialog() {
        this.cleanupInputs();
        this.setState({ replaceDialogOpen: !this.state.replaceDialogOpen });
    }

    onReplaceWord(event) {
        const key_name = event.target.id;
        this.setState({ [key_name]: event.target.value });
    }

    onLinkChange(event) {
        const key_name = event.currentTarget.id;
        this.setState({ [key_name]: event.target.value });
    }

    onDownloadLinkInsert(event) {
        // Обработка однострочных тагов
        const sel_start = this.state.current_selection.selectionStart;
        let current_value = this.state.current_selection.value || '';
        const style_code = `[games_download=${this.state.games_downloadLink}]${this.state.games_downloadSize}[/games_download]`;
        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + style_code + current_value.slice(sel_start);

        this.setState({ current_selection: event, text: current_value });
        this.onTextChange(event);
        this[`toggle${event.target.value.charAt(0).toUpperCase()}${event.target.value.substr(1)}UrlDialog`]();

        event.target.value = current_value;
        this.setState({ current_selection: event, text: current_value });
        this.onTextChange(event);
    }

    dumbFunction() {
    }

    setTranslate(message_id, social_type, text) {
        Fetcher(
            'social_translate/',
            'POST',
            this.dumbFunction,
            { message_id, social_type, text },
        );
    }

    twitchChangeHandler = (type) => {
        this.setState({ twitchType: type });
    };

    addSocialBlock() {
        const text = `${this.state.text}\n[social_links][/social_links]`;

        this.setState({
            text,
        }, () => {
            this.props.onChange({
                target: {
                    id: this.props.id,
                    type: this.props.id,
                    value: text,
                },
                currentTarget: {
                    id: this.props.id,
                    type: this.props.id,
                    value: text,
                },
                type: 'change',
            });
        });
    }

    addEntitiesBlock() {
        this.toggleEntsBlockDialog();
    }

    async onLinkInsert(event) {
        event.persist();
        const { value } = event.currentTarget;

        // Сохранение перевода сообщения
        if (this.state.twitterTranslate && this.state.twitterTranslate.length > 0) {
            const tweetIdSplit = this.state.twitterLink.split('status/');
            let tweetId = tweetIdSplit[tweetIdSplit.length - 1].match(/\d+/g);

            if (!tweetId) {
                return;
            }

            tweetId = tweetId[0];
            event.type = 'socialInsert';
            this.setTranslate(tweetId, 'twitter', this.state.twitterTranslate);
        }

        // Обработка однострочных тагов
        const result_str = this.state[`${value}Link`];

        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        let open_style_code = `[${value}=${result_str}]`;
        let close_style_code = `[/${value}]`;

        if (value === 'rawHtml') {
            const rawId = await this.setRawHTML(this.state.rawHtml);
            open_style_code = `[raw_html]${rawId}`;
            close_style_code = '[/raw_html]';
        }

        if (value === 'twitch' || value === 'instagram' || value === 'telegram') {
            const rawId = await this.socialRawId(value);
            open_style_code = `[raw_html]${rawId}`;
            close_style_code = '[/raw_html]';
        }

        if (value === 'vk_video') {
            open_style_code = `[vk_video=${this.state.vk_video}]`;
            close_style_code = '[/vk_video]';
        }

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        // Добавляем закрывающий таг
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);

        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });

        this[`toggle${value.charAt(0).toUpperCase()}${value.substr(1)}UrlDialog`]();

        event.target.value = current_value;

        if (event.currentTarget) {
            event.currentTarget.value = current_value;
        } else {
            event.currentTarget = {};
        }

        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    async setRawHTML(html) {
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ html }),
        };

        let response = await fetch('/admin_api/rawhtml/', options);
        response = await response.json();

        return response.id;
    }

    async socialRawId(value) {
        const link = this.state[`${value}Link`];
        let html = '';

        if (value === 'twitch') {
            const { twitchType, twitchLinkCollection } = this.state;

            if (twitchType === 'clip') {
                html = twitchPlaceholderClip(link);
            } else if (twitchType === 'video') {
                html = twitchPlaceholderVideo(link, twitchLinkCollection);
            } else if (twitchType === 'chanel') {
                html = twitchPlaceholder(link);
            }
        } else if (value === 'instagram') {
            let response = await fetch(`https://graph.facebook.com/v9.0/instagram_oembed/?url=${link}&access_token=${FACEBOOK.appId}|${FACEBOOK.clientToken}`);
            response = await response.json();
            html = response.html;
        } else if (value === 'telegram') {
            const post = link.split('/');
            const el1 = post[post.length - 1] ? post[post.length - 2] : post[post.length - 3];
            const el2 = post[post.length - 1] ? post[post.length - 1] : post[post.length - 2];
            html = telegramPlaceholder(`${el1}/${el2}`);
        } else {
            return;
        }

        const responseId = await this.setRawHTML(html);

        return responseId;
    }

    replaceWords() {
        this.setState({ text: this.state.text.replace(this.state.sourceReplWord, this.state.resultReplWord) });
        this.toggleReplDialog();
    }

    toggleGameLinkDialog() {
        this.cleanupInputs();
        this.setState({ gameLinkDialogOpen: !this.state.gameLinkDialogOpen });
    }

    toggleTwitterUrlDialog() {
        this.cleanupInputs();
        this.setState({ twitterUrlDialogOpen: !this.state.twitterUrlDialogOpen });
    }

    toggleTwitchUrlDialog = () => {
        this.cleanupInputs();
        this.setState({ twitchUrlDialogOpen: !this.state.twitchUrlDialogOpen });
    };

    toggleInstagramUrlDialog = () => {
        this.cleanupInputs();
        this.setState({ instagramUrlDialogOpen: !this.state.instagramUrlDialogOpen });
    };

    toggleTelegramUrlDialog = () => {
        this.cleanupInputs();
        this.setState({ telegramUrlDialogOpen: !this.state.telegramUrlDialogOpen });
    };

    toggleQuoteDialog() {
        this.cleanupInputs();
        this.setState({ quoteDialogOpen: !this.state.quoteDialogOpen });
    }

    toggleTableDialog = () => {
        this.cleanupInputs();
        this.setState({ tableDialogOpen: !this.state.tableDialogOpen });
    };

    toggleRawHtmlUrlDialog = () => {
        this.cleanupInputs();
        this.setState({ rawHtmlDialogOpen: !this.state.rawHtmlDialogOpen });
    };

    toggleAsideDialog = () => {
        this.cleanupInputs();
        this.setState({ asideDialogOpen: !this.state.asideDialogOpen });
    };

    toggleUrlUrlDialog() {
        this.cleanupInputs();
        this.setState({ linkUrlDialogOpen: !this.state.linkUrlDialogOpen });
    }

    toggleEntsBlockDialog() {
        this.cleanupInputs();
        this.setState({ entsBlockDialogOpen: !this.state.entsBlockDialogOpen });
    }

    entitySearchChange(event) {
        const data = event.target.value;
        this.setState({ foundedEntity: { ...data, type: this.state.entity_alias } });
    }

    getSelectedEntitys() {
        const res = [];

        for (let i = 0; i < this.state.selectedEntitys.length; i++) {
            res.push(
                <tr key={`tr_${i}`}>
                    <td
                        id={this.state.selectedEntitys[i].slug}
                        key={`td_${i}`}
                    >
                        {this.state.selectedEntitys[i].name}

                    </td>
                    <td>
                        <Button
                            size="sm"
                            variant="link"
                            id={`rmb_${i}`}
                            data-name={this.state.selectedEntitys[i].slug}
                            onClick={this.removeSelectedEntity}
                        >
                            <FontAwesomeIcon id={`rmf_${i}`} name={`rmf_${i}`} icon="trash" />
                        </Button>

                    </td>
                </tr>,
            );
        }

        return (
            <table>
                <tbody>{res}</tbody>
            </table>
        );
    }

    appendSelectedEntity() {
        if (!this.state.foundedEntity) {
            return;
        }

        const { selectedEntitys } = this.state;

        if (selectedEntitys.some((e) => e.slug === this.state.foundedEntity.slug)) {
            return;
        }

        selectedEntitys.push(this.state.foundedEntity);
        this.setState({ selectedEntitys });
    }

    removeSelectedEntity(event) {
        const newSelection = [];
        const slug = event.currentTarget.dataset.name;

        for (let i = 0; i < this.state.selectedEntitys.length; i++) {
            if (this.state.selectedEntitys[i].slug === slug) {
                continue;
            }

            newSelection.push(this.state.selectedEntitys[i]);
        }

        this.setState({ selectedEntitys: newSelection });
    }

    onEntityInsert(event) {
        let res = '';

        for (let i = 0; i < this.state.selectedEntitys.length; i++) {
            const ent = this.state.selectedEntitys[i];
            let ent_url = '';

            if (ent.type === 'news') {
                ent_url = buildNewsURL(ent.date_published, ent.slug, true);
            } else if (ent.type === 'compilation') {
                ent_url = buildCompilationsURL(ent.slug, true);
            } else {
                ent_url = buildArticleURL(ent.type, ent.slug, true);
            }

            if (ent.isVKP || ent.isCyber || ent.isGof) {
                ent_url = ent_url.replace('/pc/', 'https://media.vkplay.ru/');
            } else {
                ent_url = ent_url.replace('/pc/', 'https://media.vkplay.ru/');
            }

            res += (`\n[*] [url=${ent_url}] ${ent.name} [/url]`);
        }

        const ents_block = `\n[similar_articles][h3]Читайте также: [/h3]\n[list=]${res}\n[/list][/similar_articles]`;
        let current_value = this.state.text;
        current_value += `\n${ents_block}`;

        event.target.value = current_value;
        event.currentTarget.value = current_value;
        this.setState({
            text: current_value,
            entsBlockDialogOpen: false,
        });
        this.onTextChange(event);
    }

    toggleVideoUrlDialog() {
        this.cleanupInputs();
        this.setState({ videoUrlDialogOpen: !this.state.videoUrlDialogOpen });
    }

    toggleVk_videoUrlDialog = () => {
        this.cleanupInputs();
        this.setState({ videoVKUrlDialogOpen: !this.state.videoVKUrlDialogOpen });
    };

    toggleGames_downloadUrlDialog() {
        this.cleanupInputs();
        this.setState({ games_downloadUrlDialogOpen: !this.state.games_downloadUrlDialogOpen });
    }

    onGameSelection(event) {
        const game_slug = event.target.value.slug;
        const result_str = GAMES_URL + game_slug;

        if (!game_slug) {
            return;
        }

        // Обработка однострочных тагов
        const sel_start = this.state.current_selection.selectionStart;
        const sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';
        const open_style_code = `[b][url=${result_str}]`;
        const close_style_code = '[/url][/b]';
        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        // Добавляем закрывающий таг
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);

        if (!event.noModal) {
            this.toggleGameLinkDialog();
        }

        event.multiData = {
            id: 'games',
            value: {
                id: event.target.value.value,
                name: event.target.value.name,
                slug: event.target.value.slug,
            },
        };

        if (!event.multiData.value.id) {
            toast.error('Код 001. У игры отсутствует ID.');
        }

        event.currentTarget.value = current_value;
        event.target.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    cleanupInputs() {
        this.setState({
            entity_alias: 'news',
            selectedEntitys: [],
            foundedEntity: undefined,
            sourceReplWord: '',
            resultReplWord: '',
            twitterLink: '',
            twitchLink: '',
            instagramLink: '',
            telegramLink: '',
            twitterTranslate: '',
            urlLink: '',
            videoLink: '',
            games_downloadLink: '',
            games_downloadSize: '',
            quote_type: '',
            quote_author: '',
            quote_userpic: '',
            quote_text: '',
            main_quote: false,
        });
    }

    pictureSelected(e) {
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = this.state.current_selection.selectionEnd;
        let current_value = this.state.current_selection.value || '';

        let open_style_code = `[games_img=${e.id}]`;
        let close_style_code = '[/games_img]\n';

        const isGif = !!e.filename && e.filename.slice(-3) === 'mp4';

        if (isGif) {
            open_style_code = `[games_gif=${e.id}]`;
            close_style_code = '[/games_gif]\n';
        }

        if (this.props.isStory) {
            open_style_code = `[media_img=${e.id}]`;
            close_style_code = '[/media_img]\n';
        }

        // Если курсор не в окне ввода

        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + open_style_code + current_value.slice(sel_start);
        // Добавляем закрывающий таг
        current_value = current_value.slice(0, sel_end + open_style_code.length) + close_style_code + current_value.slice(sel_end + open_style_code.length);

        const event = {
            target: {
                value: current_value,
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
            currentTarget: {
                value: current_value,
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
            },
        };

        this.setState({
            current_selection: {
                selectionStart: sel_end + open_style_code.length + close_style_code.length,
                selectionEnd: sel_end + open_style_code.length + close_style_code.length,
                value: current_value,
            },
            text: current_value,
        });
        this.onTextChange(event);

        return e.id;
    }

    onQuoteEdit(event) {
        let { value } = event.currentTarget;

        if (event.currentTarget.type === 'checkbox') {
            value = event.currentTarget.checked;
        }

        this.setState({ [event.currentTarget.id]: value });
    }

    onQuoteInsert(event) {
        // Обработка однострочных тагов
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = sel_start;
        let current_value = this.state.current_selection.value || this.state.text;

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        let quote_type = 'mini';

        if (this.state.main_quote) {
            quote_type = 'main';
        }

        let start_tag = `[quote=${quote_type}][quote_text]${this.state.quote_text}[/quote_text]`;
        const end_tag = '[/quote]';

        if (this.state.quote_userpic) {
            start_tag += `[quote_author_userpic]${this.state.quote_userpic}[/quote_author_userpic]`;
        }

        if (this.state.quote_author) {
            start_tag += `[quote_author]${this.state.quote_author}[/quote_author]`;
        }

        const style_code = start_tag + end_tag;

        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + style_code + current_value.slice(sel_start);

        this.setState({
            current_selection: {
                selectionStart: sel_start + style_code.length,
                selectionEnd: sel_start + style_code.length,
            },
            text: current_value,
        });

        this.toggleQuoteDialog();

        event.target.value = current_value;
        event.currentTarget.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_start + style_code.length,
                selectionEnd: sel_start + style_code.length,
            },
            text: current_value,
        });
        this.onTextChange(event);
    }

    tableUpdateHandler(data, closeDialog, tag, option) {
        // Обработка однострочных тагов
        let sel_start = this.state.current_selection.selectionStart;
        let sel_end = sel_start;
        let current_value = this.state.current_selection.value || this.state.text;

        // Если курсор не в окне ввода
        if (!sel_start && !sel_end) {
            current_value = this.state.text;
            sel_start = this.state.text.length;
            sel_end = sel_start;
        }

        let htmlTag = `[${tag}]${data.id}[/${tag}]`;

        if (option) {
            htmlTag = `[${tag}=${option}]${data.id}[/${tag}]`;
        }

        // Добавляем открывающий таг
        current_value = current_value.slice(0, sel_start) + htmlTag + current_value.slice(sel_start);

        closeDialog();

        const customEvent = { target: {}, currentTarget: {} };
        customEvent.target.value = current_value;
        customEvent.currentTarget.value = current_value;
        this.setState({
            current_selection: {
                selectionStart: sel_start + htmlTag.length,
                selectionEnd: sel_start + htmlTag.length,
            },
            text: current_value,
        });

        this.onTextChange(customEvent);
    }

    onTableInsert = (event) => {
        const { table } = this.state;

        const tag = event.currentTarget.value;
        Fetcher(
            'tablehtml/',
            'POST',
            (data) => this.tableUpdateHandler(data, this.toggleTableDialog, tag),
            { html: table.html, json: table.grid },
        );
    };

    onAsideInsert = () => {
        const id = this.state.currentMaterial.value;
        this.tableUpdateHandler({ id }, this.toggleAsideDialog, 'aside_material', this.state.materialType);
    };

    handleMaterialTypeChange = (event) => {
        this.setState({ materialType: event.currentTarget.value });
    };

    getSearchUrl = () => {
        const { materialType } = this.state;

        if (materialType === 'news') {
            return 'news/';
        }

        if (materialType === 'video') {
            return 'videos/?type=trailer';
        }

        return `articles/${materialType}/`;
    };

    handleMaterialChange = (event) => {
        this.setState({ currentMaterial: event.currentTarget.value });
    };

    entityTypeSelected(event) {
        this.setState({ entity_alias: event.target.value });
    }

    entityProjectSelected = (event) => {
        this.setState({ more_project: event.target.value });
    };

    renderPopupLabel = (isSub) => (
        <span style={isSub ? labelStyleSub : labelStyle}>
            {isSub ? 'Коллекция' : twitchTypeLabel[this.state.twitchType]}
        </span>
    );

    renderTwitchExample = () => {
        const { twitchType } = this.state;

        if (twitchType === 'clip') {
            return (
                <p style={{ color: '#999' }}>
                    Пример: https://www.twitch.tv/mcdm/clip/
                    <span style={labelStyle}>FaintNaiveRingHeyGirl</span>
                    /
                </p>
            );
        }

        if (twitchType === 'video') {
            return (
                <p style={{ color: '#999' }}>
                    Пример: https://www.twitch.tv/videos/
                    <span style={labelStyle}>372767247</span>
                    ?collection=
                    <span style={labelStyleSub}>HfLmd5zdfhUBJw</span>
                    /
                </p>
            );
        }

        if (twitchType === 'chanel') {
            return (
                <p style={{ color: '#999' }}>
                    Пример: https://www.twitch.tv/
                    <span style={labelStyle}>mcdm</span>
                    /
                </p>
            );
        }
    };

    render() {
        let text_block = this.textInputBlock();

        if (this.state.isPreview) {
            text_block = this.textPreviewBlock();
        }

        let buttons_blocks = '';

        if (this.props.lessControls) {
            buttons_blocks = [this.inlineStyleBlock(), this.headersStyleBlock(), this.listStyleBlock(), this.specSymbolsBlock(), this.linksStyleShortBlock(), this.textChunksBlock()];
        } else if (this.props.id === 'descr' || this.props.id === 'features' || this.props.id === 'native_descr' || this.props.id === 'fact_text' || this.props.id === 'seo_text') {
            buttons_blocks = [this.inlineStyleBlock(), this.linksStyleShortBlock()];
        } else {
            buttons_blocks = [this.inlineStyleBlock(), this.headersStyleBlock(), this.listStyleBlock(),
                this.specSymbolsBlock(), this.linksStyleBlock(), this.formatActionsBlock(), this.footerBlock()];
        }

        const keyMap = {
            undoText: ['ctrl+z', 'command+z'],
            redoText: ['ctrl+y', 'command+shift+z'],
            boldText: ['ctrl+b', 'command+b'],
            italicText: ['ctrl+i', 'command+i'],
            underlineText: ['ctrl+u', 'command+u'],
            strikeText: ['ctrl+s', 'command+s'],
            linkText: ['ctrl+l', 'command+l'],
            twitterLinkText: ['ctrl+t', 'command+t'],
            gameLinkText: ['ctrl+g', 'command+g'],
            videoLinkText: ['ctrl+m', 'command+m'],
        };

        const handlers = {
            undoText: this.getTextFromHistoryUndo,
            redoText: this.getTextFromHistoryRedo,
            boldText: (e) => {
                e.preventDefault();
                this.onInlineStyleChange({
                    currentTarget: { id: 'b_code' },
                    target: { id: 'b_code' },
                });
            },
            italicText: (e) => {
                e.preventDefault();
                this.onInlineStyleChange({
                    currentTarget: { id: 'i_code' },
                    target: { id: 'i_code' },
                });
            },
            underlineText: (e) => {
                e.preventDefault();
                this.onInlineStyleChange({
                    currentTarget: { id: 'u_code' },
                    target: { id: 'u_code' },
                });
            },
            strikeText: (e) => {
                e.preventDefault();
                this.onInlineStyleChange({
                    currentTarget: { id: 's_code' },
                    target: { id: 's_code' },
                });
            },
            linkText: (e) => {
                e.preventDefault();
                this.toggleUrlUrlDialog();
            },
            twitterLinkText: (e) => {
                e.preventDefault();
                this.toggleTwitterUrlDialog();
            },
            gameLinkText: (e) => {
                e.preventDefault();
                this.toggleGameLinkDialog();
            },
            videoLinkText: (e) => {
                e.preventDefault();
                this.toggleVideoUrlDialog();
            },
        };

        const selected_text = this.state.text.slice(
            this.state.current_selection.selectionStart,
            this.state.current_selection.selectionEnd,
        );

        let entityAPI = '';

        const alias = this.state.entity_alias || 'news';

        entityAPI = `v2/${this.state.more_project || PROJECT_DOMAINS[0].id}/story/${alias}/`;

        return (
            <HotKeys keyMap={keyMap} handlers={handlers}>
                <div>
                    {!this.props.noControls && (
                        <Row>
                            <Col md={12}>
                                <ButtonToolbar>
                                    {buttons_blocks}
                                    <ButtonGroup className="mb-2" key="defaultButtons">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            title="Отменить"
                                            id="url_code"
                                            onClick={this.getTextFromHistoryUndo}
                                            href="#"
                                        >
                                            <FontAwesomeIcon icon="undo" />
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            title="Повторить"
                                            id="url_code"
                                            onClick={this.getTextFromHistoryRedo}
                                            href="#"
                                        >
                                            <FontAwesomeIcon icon="redo" />
                                        </Button>
                                    </ButtonGroup>
                                </ButtonToolbar>
                            </Col>
                        </Row>
                    )}
                    <FormGroup controlId="formControlsTextarea">
                        {text_block}
                        <div className="text-right" style={{ fontSize: '90%' }}>{this.props.extras}</div>
                    </FormGroup>

                    <StdModalDialog
                        isOpen={this.state.replaceDialogOpen}
                        container={this}
                        hideHandler={this.toggleReplDialog}
                        closeHandler={this.toggleReplDialog}
                        title="Автозамена"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="sourceReplWord"
                                            label="Заменить слово"
                                            value={this.state.sourceReplWord}
                                            onChange={this.onReplaceWord}
                                            forwardRef={this.replaceWordRef}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="resultReplWord"
                                            label="На"
                                            value={this.state.resultReplWord}
                                            onChange={this.onReplaceWord}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.replaceWords}
                    />

                    <StdModalDialog
                        isOpen={this.state.gameLinkDialogOpen}
                        container={this}
                        hideHandler={this.toggleGameLinkDialog}
                        closeHandler={this.toggleGameLinkDialog}
                        title="Ссылка на игру"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <SearchSelectorField
                                            name="gameLink"
                                            label=""
                                            onChange={this.onGameSelection}
                                            uri={`${API_DOMAIN}games/`}
                                            searchValue={selected_text}
                                            isMulti={false}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.toggleGameLinkDialog}
                    />

                    <StdModalDialog
                        isOpen={this.state.twitterUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleTwitterUrlDialog}
                        closeHandler={this.toggleTwitterUrlDialog}
                        title="Twitter"
                        id="twitter"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="twitterLink"
                                            label="Ссылка"
                                            value={this.state.twitterLink}
                                            onChange={this.onLinkChange}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <TextAreaField
                                            name="twitterTranslate"
                                            label="Перевод"
                                            value={this.state.twitterTranslate}
                                            onChange={this.onLinkChange}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.twitchUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleTwitchUrlDialog}
                        closeHandler={this.toggleTwitchUrlDialog}
                        title="Twitch"
                        id="twitch"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12} className="mb-4">
                                        <ToggleButtonGroup
                                            value={this.state.twitchType}
                                            name="twitchType"
                                            type="radio"
                                            onChange={this.twitchChangeHandler}
                                        >
                                            <ToggleButton variant="outline-secondary" value="clip"> Клип </ToggleButton>
                                            <ToggleButton variant="outline-secondary" value="video"> Видео </ToggleButton>
                                            <ToggleButton variant="outline-secondary" value="chanel"> Канал </ToggleButton>
                                        </ToggleButtonGroup>
                                    </Col>
                                    <Col md={12}>
                                        {this.renderTwitchExample()}
                                    </Col>
                                    <Col md={this.state.twitchType === 'video' ? 6 : 12}>
                                        <InputField
                                            required
                                            name="twitchLink"
                                            label={this.renderPopupLabel()}
                                            value={this.state.twitchLink}
                                            onChange={this.onLinkChange}
                                            placeholder={twitchPlaceholders[this.state.twitchType]}
                                        />
                                    </Col>
                                    {this.state.twitchType === 'video' && (
                                        <Col md={6}>
                                            <InputField
                                                name="twitchLinkCollection"
                                                label={this.renderPopupLabel(true)}
                                                value={this.state.twitchLinkCollection}
                                                onChange={this.onLinkChange}
                                                placeholder="HfLmd5zdfhUBJw"
                                                noAutoFocus
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.instagramUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleInstagramUrlDialog}
                        closeHandler={this.toggleInstagramUrlDialog}
                        title="Instagram"
                        id="instagram"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="instagramLink"
                                            label="URL поста"
                                            value={this.state.instagramLink}
                                            onChange={this.onLinkChange}
                                            placeholder="https://www.instagram.com/p/CEqyhaxsutL/"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.telegramUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleTelegramUrlDialog}
                        closeHandler={this.toggleTelegramUrlDialog}
                        title="Telegram"
                        id="telegram"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="telegramLink"
                                            label="URL поста"
                                            value={this.state.telegramLink}
                                            onChange={this.onLinkChange}
                                            placeholder="https://t.me/forwebdev/5898"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.linkUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleUrlUrlDialog}
                        closeHandler={this.toggleUrlUrlDialog}
                        title="Ссылка"
                        id="url"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="urlLink"
                                            label="Вставьте ссылку"
                                            value={this.state.urlLink}
                                            onChange={this.onLinkChange}
                                            forwardRef={this.linkUrlRef}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.videoUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleVideoUrlDialog}
                        closeHandler={this.toggleVideoUrlDialog}
                        title="Видео"
                        id="video"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="videoLink"
                                            label="Ссылка"
                                            value={this.state.videoLink}
                                            onChange={this.onLinkChange}
                                            forwardRef={this.videoUrlRef}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.videoVKUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleVk_videoUrlDialog}
                        closeHandler={this.toggleVk_videoUrlDialog}
                        title="Видео из VK"
                        id="vk_video"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="vk_video"
                                            label="Ссылка"
                                            placeholder="https://vk.com/video_ext.php?oid=-54878061&id=456240056&hash=fe9f88174fd07801&hd=2"
                                            value={this.state.videoVKLink}
                                            onChange={this.onLinkChange}
                                            forwardRef={this.videoUrlRef}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-0">
                                    <Col md={12}>
                                        <Accordion>
                                            <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                                <FontAwesomeIcon icon="question-circle" />
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="0">
                                                <img src="https://vkplay.ru/hotbox/content_files/media/1662971360_video-vk-hint.png" alt="" />
                                            </Accordion.Collapse>
                                        </Accordion>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.games_downloadUrlDialogOpen}
                        container={this}
                        hideHandler={this.toggleGames_downloadUrlDialog}
                        closeHandler={this.toggleGames_downloadUrlDialog}
                        title="Файл"
                        id="games_download"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="games_downloadLink"
                                            label="Ссылка на файл"
                                            value={this.state.games_downloadLink}
                                            onChange={this.onLinkChange}
                                            forwardRef={this.gameUrlRef}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="games_downloadSize"
                                            label="Размер файла"
                                            value={this.state.games_downloadSize}
                                            onChange={this.onLinkChange}
                                            placeholder="1Гб"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onDownloadLinkInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.quoteDialogOpen}
                        container={this}
                        hideHandler={this.toggleQuoteDialog}
                        closeHandler={this.toggleQuoteDialog}
                        title="Цитата"
                        id="quote"
                        body={(
                            <div>
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <CheckboxField
                                            name="main_quote"
                                            label="Цитата с кавычками"
                                            value={this.state.main_quote}
                                            onChange={this.onQuoteEdit}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <ButtonToolbar>
                                            {this.getQuoteButtons()}
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <TextAreaField
                                            name="quote_text"
                                            value={this.state.quote_text}
                                            onChange={this.onQuoteEdit}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="quote_userpic"
                                            label="Юзерпик автора (URL)"
                                            value={this.state.quote_userpic}
                                            onChange={this.onQuoteEdit}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <InputField
                                            name="quote_author"
                                            label="Автор"
                                            value={this.state.quote_author}
                                            onChange={this.onQuoteEdit}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onQuoteInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.tableDialogOpen}
                        container={this}
                        hideHandler={this.toggleTableDialog}
                        closeHandler={this.toggleTableDialog}
                        title="Таблица"
                        id="table_html"
                        hotkeysDisabled
                        body={(
                            <EditableTable
                                onChange={this.handleTableChange}
                            />
                        )}
                        onSave={this.onTableInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.asideDialogOpen}
                        container={this}
                        hideHandler={this.toggleAsideDialog}
                        closeHandler={this.toggleAsideDialog}
                        title="Вставка"
                        id="aside_article"
                        hotkeysDisabled
                        body={(
                            <>
                                <SelectorField
                                    name="material-type"
                                    label="Тип материала"
                                    options={ENT_TYPES}
                                    selected={this.state.materialType}
                                    onChange={this.handleMaterialTypeChange}
                                />
                                <br />
                                <SearchSelectorField
                                    name="material-entity"
                                    label="Материал"
                                    uri={API_DOMAIN + this.getSearchUrl()}
                                    isMulti={false}
                                    onChange={this.handleMaterialChange}
                                />
                                {this.state.currentMaterial
                                && (
                                    <p>
                                        Выбранный материал:
                                        <b>{this.state.currentMaterial.label}</b>
                                    </p>
                                )}
                            </>
                        )}
                        onSave={this.onAsideInsert}
                    />

                    <StdModalDialog
                        isOpen={this.state.entsBlockDialogOpen}
                        container={this}
                        hideHandler={this.toggleEntsBlockDialog}
                        closeHandler={this.toggleEntsBlockDialog}
                        title="Материалы по теме"
                        id="entsBlockDialog"
                        body={(
                            <div>
                                <Row>
                                    <Col md={2}>
                                        <SelectorField
                                            name="project"
                                            label="Проект"
                                            options={PROJECT_DOMAINS}
                                            selected={this.state.more_project}
                                            onChange={this.entityProjectSelected}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <SelectorField
                                            name="alias"
                                            label="Тип"
                                            options={ENT_TYPES}
                                            selected={this.state.entity_alias}
                                            onChange={this.entityTypeSelected}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <SearchSelectorField
                                            name="entity"
                                            label="Материал"
                                            value={[this.state.foundedEntity]}
                                            uri={API_DOMAIN + entityAPI}
                                            onChange={this.entitySearchChange}
                                            isMulti={false}
                                            publishedOnly
                                            keepSearchOnClose
                                        />
                                    </Col>
                                    <Col md={1} style={{ paddingTop: 32 }}>
                                        <Button onClick={this.appendSelectedEntity} variant="outline-dark" block>
                                            <FontAwesomeIcon style={{ paddingRight: 5 }} icon="plus" />
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        {this.getSelectedEntitys()}
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onEntityInsert}
                    />
                    <StdModalDialog
                        isOpen={this.state.rawHtmlDialogOpen}
                        container={this}
                        hideHandler={this.toggleRawHtmlUrlDialog}
                        closeHandler={this.toggleRawHtmlUrlDialog}
                        title="Сырой HTML"
                        id="rawHtml"
                        body={(
                            <div>
                                <Row>
                                    <Col md={12} className="mb-4">
                                        <TextAreaField
                                            name="rawHtml"
                                            value={this.state.rawHtml}
                                            onChange={this.onQuoteEdit}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                        onSave={this.onLinkInsert}
                    />
                </div>
            </HotKeys>
        );
    }
}
